import axios from "axios";

const token = localStorage.getItem("wow-delivery-kw-merchant-token");

const PUT = async (endpoint, data) => {
  const response = await axios.put(endpoint, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response;
};

export default PUT;
